export const vehicleTypes: IVehicleType[] = [
  'A',
  'A1',
  'B',
  'C',
  'D',
  'BE',
  'CE',
  'DE',
];
export default vehicleTypes;
